<section>
  @if (content()) {
    <app-card>
      <div class="flex justify-between items-center p-5">
        <a (click)="goBack()">
          <app-icon
            [width]="30"
            [height]="30"
            color="var(--blue)"
            path="/assets/icons/arrow-circle-left.svg"
          />
        </a>
      </div>

      <section class="p-5 bg-white text-blue">
        <h1 class="text-xl font-bold">{{ content()?.title }}</h1>
        <p class="text-sm text-gray-400">Version {{ content()?.version }}</p>

        @for (section of content()?.sections; track $index; let idx = $index) {
          <app-section
            [section]="section"
            [hierarchyPath]="[idx + 1]"
          />
        }
      </section>
    </app-card>
  }
</section>
